import { render, staticRenderFns } from "./ExtraOptionContainer.vue?vue&type=template&id=079063b1"
import script from "./ExtraOptionContainer.vue?vue&type=script&lang=ts"
export * from "./ExtraOptionContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports